module.exports = __webpack_public_path__ + "static/media/award-post-bg.3ab4569d.svg";